export const Strings = {
  trackingId: "UA-153881983-2",
  TEST_API: "//localhost:8000/api/",
  YOUTUBE_API_KEY: "AIzaSyAxfFckdSldPkOysmW0Wbqish1UJlE1ECE",
};
